export { default } from './Trend';



// WEBPACK FOOTER //
// ./src/components/Trend/index.js